module.exports = __webpack_public_path__ + "img/not-resturant.39bc2769.svg";